module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"qrCodeBtn":"Voir le QR Code"},"en":{"qrCodeBtn":"Show the QR Code"}}')
  delete Component.options._Ctor
}
